const templateUrl = require('./../views/partials/paypalform.html');

function PaypalFormController ($sce, $state, Program, Cause, ReferrerService, ConfigEnvironment) {
  "ngInject";

  this.$onInit = () => {

    console.log('__paypalForm__');
    
    console.log(this);

    const registration = JSON.parse(this.registration);

    console.log(registration);

    //env is variable for testing purposes via ConfigEnvironment.setConfiguration
    let env;
   
    let programFilter = {
      "cause_id": registration.selected_cause.id,
      "referred_by": ReferrerService.getReferredBy()
    };

    Cause.getPrograms(programFilter).$promise.then((programs) => {
      this.programs = programs.programs;
    }).catch(function(err) {
      console.error("Unable to retrieve programs", err);
    });

    this.proceedToCheckout = function($event) {
      $event.preventDefault();
      document.getElementById('paypalform').submit();
    }

    var returnUrl;
    
    this.selectProgram = () => {
      
      //redeclared for testing purposes
      env = ConfigEnvironment.getConfiguration("env");

      Program.findOne({
        "filter": {
          "where": {"id": this.program_id}
        }
      }).$promise.then((program) => {
        this.selectedProgram = program;  

        let customVars = `subscriber_id=${registration.subscriber_id}&program_id=` +
          `${this.program_id}&cause_id=${registration.selected_cause.id}`;

        //grab additional arbitrary param passed through referred by

        if(programFilter.referred_by && programFilter.referred_by.entity_id) {

          customVars += "&rb_entity_id=" + programFilter.referred_by.entity_id;
        
          if(programFilter.referred_by.entity_type) {
            customVars += "&rb_entity_type=" + programFilter.referred_by.entity_type;
          }

          if(programFilter.referred_by.subentity_id) {
            customVars += "&rb_subentity_id=" + programFilter.referred_by.subentity_id;
          }
        
          if(programFilter.referred_by.referrer_id) {
            customVars += "&rb_referrer_id=" + programFilter.referred_by.referrer_id;
          }
        }

        //base64decode to prevent paypal from barfing
        this.custom_vars = btoa(customVars);

        returnUrl = $state.href('join.receipt', {}, {absolute: true}) + "?" + customVars;
        
        this.return_url = $sce.trustAsResourceUrl(returnUrl);
        
        var notifyUrl = ConfigEnvironment.getConfiguration("greenback") 
          + "api/payment_transactions/1cd2008d0bd202d255a2a0c43fe7a157";
        
        this.notify_url = $sce.trustAsResourceUrl(notifyUrl);  

        this.setFormActionAndBusinessEmail(registration);
        console.log(this.custom_vars);
      }).catch(function(err) {
        return false;
      });
    }

    this.setFormActionAndBusinessEmail = (registration) => {

      let paypalAction;

      if(env === "prod") {
        paypalAction = "https://www.paypal.com/cgi-bin/webscr";
        this.businessEmail = registration.selected_cause.paypal || "accounting@startupmedia.com";
      }
      else {
        paypalAction = "https://www.sandbox.paypal.com/cgi-bin/webscr";
        this.businessEmail = "accounting-facilitator@startupmedia.com";
      }

      this.form_action = $sce.trustAsResourceUrl(paypalAction);
    }

    this.cancel_url = $sce.trustAsResourceUrl($state.href('join.setup', {}, {absolute: true}));
  }
}


const component = {
  bindings: {
    registration: '@'
  },
  controller: PaypalFormController,
  templateUrl,
  restrict: 'E'
}

export default component;



// WEBPACK FOOTER //
// ./js/containers/users/components/paypalform.js